import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import Dashboard from "@/pages/Dashboard";
import About from "@/pages/About";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0F17] text-slate-100">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#121824",
            border: "1px solid #1E293B",
            color: "#F8FAFC",
            fontFamily: "'JetBrains Mono', monospace",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
